import { money } from "./format";

// Colores y formato de «Pago de plataformas» (#956 / #957).

export const GAP_TONES: Record<string, string> = {
  ok: "bg-emerald-500/15 text-emerald-600",
  falta_factura: "bg-amber-500/15 text-amber-600",
  falta_cargo: "bg-sky-500/15 text-sky-600",
  sin_movimiento: "bg-gray-400/15 text-gray-500",
};

export const KIND_TONES: Record<string, string> = {
  cfdi: "bg-emerald-500/15 text-emerald-600",
  factura_extranjera: "bg-indigo-500/15 text-indigo-600",
};

/** Tipo de pago: plataforma (herramienta del equipo) o infraestructura (lo que corre el producto). */
export const KIND_COLORS: Record<string, string> = { plataforma: "#6366f1", infraestructura: "#0d9488" };
export const PLATFORM_KIND_TONES: Record<string, string> = {
  plataforma: "bg-indigo-500/15 text-indigo-600 dark:text-indigo-300",
  infraestructura: "bg-teal-500/15 text-teal-700 dark:text-teal-300",
};

export const MODEL_TONES: Record<string, string> = {
  asiento: "bg-violet-500/15 text-violet-600",
  servicio: "bg-teal-500/15 text-teal-600",
  consumo: "bg-orange-500/15 text-orange-600",
};

/** "MXN 1,000 + USD 150" sin mezclar monedas; "—" si no hay nada. */
export function currencyTotals(byCurrency: Record<string, number>, language = "es"): string {
  const entries = Object.entries(byCurrency).sort(([a], [b]) => (a === "MXN" ? -1 : b === "MXN" ? 1 : a.localeCompare(b)));
  return entries.map(([cur, v]) => money(v, cur, language)).join(" + ") || "—";
}

/** 0.3 → "+30 %". */
export function percentChange(change: number | null | undefined, language = "es"): string {
  if (change == null || !Number.isFinite(change)) return "—";
  const pct = new Intl.NumberFormat(language.startsWith("en") ? "en-US" : "es-MX", { style: "percent", maximumFractionDigits: 0 }).format(Math.abs(change));
  return `${change >= 0 ? "+" : "−"}${pct}`;
}
